
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import httpClient from "../store/httpClient";
import DatePicker from "../components/DatePicker.vue";
import TimePicker from "@/components/TimePicker.vue";

@Component({
	components: {
		"date-picker": DatePicker,
		"time-picker": TimePicker,
	},
})
export default class Log extends Vue {
	private logs: any = [];
	private loading: boolean = false;
	private startDateString: string = moment().format("YYYY-MM-DD");
	private startTimeString: string = "23:59:59";
	private oldSuche: string = "";
	private suche: string = "";
	private systems: any = [
		{ text: "Erp", value: "Erp" },
		{ text: "Shop", value: "Kundenportal" },
		{ text: "Helpdesk", value: "Helpdesk" },
		{ text: "Fertigung", value: "Fertigerportal" },
		{ text: "CalculateApi", value: "CalculateApi" },
		{ text: "Monitor", value: "Monitor" },
		{ text: "Identity", value: "Identity" },
		{ text: "Packaging", value: "Packaging" },
		{ text: "Ameisi", value: "Ameisi" },
		{ text: "Cam", value: "Cam" },
	];
	private system: any = [];
	private oldSystem: any = [];
	private levels: any = ["Debug", "Information", "Warning", "Error", "Fatal"];
	private level: any = ["Information", "Warning", "Error", "Fatal"];
	private oldLevel: any = ["Information", "Warning", "Error", "Fatal"];
	private headers = [
		{ text: "System", value: "system", sortable: false },
		{ text: "Level", value: "level", sortable: false },
		{ text: "Time", value: "timeStamp", sortable: false },
		{ text: "Message", value: "message", sortable: false },
		{ text: "Exception", value: "exception", sortable: false },
	];

	private mounted() {
		this.setFromStoredFilters();
		this.loadLog(true);
	}

	private onSearchChanged() {
		if (this.suche === null) this.suche = "";
		if (this.suche !== this.oldSuche) {
			this.storeFilters();
			this.loadLog(true);
			this.oldSuche = this.suche;
		}
	}

	private onSearchCleared() {
		this.suche = "";
		this.onSearchChanged();
	}

	private onSystemsChanged() {
		if (
			this.system.length !== this.oldSystem.length ||
			!this.system.every(
				(item: any, index: number) =>
					item.text === this.oldSystem[index].text &&
					item.value === this.oldSystem[index].value
			)
		) {
			this.oldSystem = JSON.parse(JSON.stringify(this.system));
			this.storeFilters();
			this.loadLog(true);
		}
	}

	private onLevelsChanged() {
		if (
			this.level.length !== this.oldLevel.length ||
			!this.level.every((value: string, index: number) => value === this.oldLevel[index])
		) {
			this.oldLevel = JSON.parse(JSON.stringify(this.level));
			this.storeFilters();
			this.loadLog(true);
		}
	}

	private async loadLog(reload: boolean) {
		if (this.loading) return;
		try {
			this.loading = true;
			let from = 0;
			if (!reload) {
				from = this.logs.length;
			}
			const dateTimeString = `${this.startDateString}T${this.startTimeString}`;
			const response = await httpClient().get(
				`Log/GetLogs?skip=${from}&take=50&start=${dateTimeString}` +
					`&suche=${this.suche}&system=${this.systemValue}&level=${this.level}`
			);
			if (reload) {
				this.logs = response.data;
			} else {
				response.data.forEach((c: any) => {
					const logIndex = this.logs.findIndex((log: any) => log.id == c.id);
					if (logIndex >= 0) {
						this.logs.splice(logIndex, 1, c);
					} else {
						this.logs.push(c);
					}
				});
			}
		} catch {
			this.$store.commit("setSnackbarErrorText", "Fehler beim Laden der Logs.");
		} finally {
			this.loading = false;
		}
	}

	private get systemValue() {
		return this.system.map((s: any) => s.value);
	}

	private setStartDate(date: string) {
		this.startDateString = date;
		this.loadLog(true);
	}

	private setStartTime(time: string) {
		this.startTimeString = time;
		this.loadLog(true);
	}

	private formattedMessage(message: string) {
		var textArea = document.createElement("textarea");
		textArea.innerHTML = message;
		let newMessage = textArea.innerHTML.replace(/(?:\r\n|\r|\n)/g, "<br>");
		return newMessage;
	}

	private checkBottom() {
		let bottomOfWindow =
			window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;
		if (bottomOfWindow && !this.loading) {
			this.loadLog(false);
		}
	}

	private setFromStoredFilters() {
		const storedFilters = localStorage.getItem("logFilters");
		if (storedFilters) {
			const parsedFilters = JSON.parse(storedFilters);
			if (parsedFilters.searchterm) {
				this.oldSuche = parsedFilters.searchterm;
				this.suche = parsedFilters.searchterm;
			}
			if (parsedFilters.systems) {
				this.oldSystem = parsedFilters.systems;
				this.system = parsedFilters.systems;
			}
			if (parsedFilters.levels) {
				this.oldLevel = parsedFilters.levels;
				this.level = parsedFilters.levels;
			}
		}
	}

	private storeFilters() {
		localStorage.setItem(
			"logFilters",
			JSON.stringify({
				searchterm: this.suche,
				systems: this.system,
				levels: this.level,
			})
		);
	}

	private resetFilters() {
		localStorage.removeItem("logFilters");
		this.suche = "";
		this.system = [];
		this.level = ["Information", "Warning", "Error", "Fatal"];
		this.startDateString = moment().format("YYYY-MM-DD");
		this.startTimeString = "23:59:59";
		this.loadLog(true);
	}

	beforeRouteEnter(to: any, from: any, next: any) {
		next((vm: any) => {
			window.addEventListener("scroll", vm.checkBottom);
		});
	}

	beforeRouteLeave(to: any, from: any, next: any) {
		window.removeEventListener("scroll", this.checkBottom);
		next();
	}

	private truncate(value: string, length: number) {
		if (!value) return "";
		return value.length > length ? value.substring(0, length) + "…" : value;
	}
}
